import { Component, input } from '@angular/core';
import { NgxQrcodeStylingComponent } from 'ngx-qrcode-styling';

@Component({
  selector: 'dojo-qr-code',
  template: `
    <ngx-qrcode-styling
      [data]="content()"
      [width]="144"
      [height]="144"
      [qrOptions]="{
        errorCorrectionLevel: 'L'
      }"
      [dotsOptions]="{
        color: '#000000'
      }"
      [backgroundOptions]="{
        color: '#ffffff'
      }"
      [cornersDotOptions]="{
        color: '#000000',
        type: 'square'
      }"
      [cornersSquareOptions]="{
        type: 'square'
      }"
    />
  `,
  imports: [NgxQrcodeStylingComponent],
})
export class QrCodeComponent {
  readonly content = input.required<string>();
}
